/**
 * HASTY BAKE CUSTOMIZER - FULL UNIFIED LOGIC
 * Version: 2.2 (Integrated Download & Final Mobile Step)
 */

document.addEventListener("DOMContentLoaded", function() {

  // --- 1. CONFIGURATION & GLOBAL STATE ---
  const SAVE_URL = "https://hastybake-save-config-eta.vercel.app/api/save-customization";
  
  var customerId = null || 
                   window?.Shopify?.customer?.id || 
                   (window.ShopifyAnalytics?.meta?.page?.customerId) || 
                   null;

  const stainlessHoodId = "50544088809752";
  const stainlessBaseId = "50544094970136";
  const stainlessReactiveParts = ["thermo", "hood_badge"];
  
  let allDesigns = {};
  let currentDesignId = null;

  // --- 2. FORMATTING HELPERS ---
  function formatMoneySafe(cents) {
    const locale = null || "en-US";
    const currency = null || "USD";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency
    }).format((cents || 0) / 100);
  }

  // --- 3. CORE CUSTOMIZER LOGIC ---
  function autoSelectSwatches() {
    document.querySelectorAll(".swatches").forEach(function(swatchGroup) {
      const part = swatchGroup.dataset.part;
      if (swatchGroup.style.display === "none") return;

      let swatches = Array.from(swatchGroup.querySelectorAll(".variant-swatch"));
      let validSwatches = swatches.filter(s => s.textContent.trim() !== "None");

      if (validSwatches.length > 0) {
        validSwatches[0].click();
      }
    });

  }

function initSwatchesAndPreview() {
    const swatches = document.querySelectorAll(".variant-swatch");
    let isStainlessHood = false;

swatches.forEach(function(swatch) {
  swatch.addEventListener("click", function() {
    // 'this' is the clicked button
    const part = this.closest(".swatches").dataset.part;

    // 1. Check for stainless status
    if (part === "hood") {
      isStainlessHood = (this.dataset.variantId === stainlessHoodId);
    }
    
    // 2. UI Selection logic
    const swatchGroup = this.closest(".swatches");
    swatchGroup.querySelectorAll(".variant-swatch").forEach(s => s.classList.remove("selected"));
    this.classList.add("selected");

    // 3. Update titles and prices (On the main page)
    const titleTargetId = this.getAttribute("data-title-target");
    const titleTarget = document.getElementById(titleTargetId);
    const variantTitle = this.getAttribute("data-title") || "None";

    if (titleTarget) {
      const priceString = this.getAttribute("data-price") || "$0";
      const numericPrice = Math.round(parseFloat(priceString.replace(/[^0-9.]/g, "")) * 100);
      titleTarget.textContent = variantTitle;
      titleTarget.dataset.price = numericPrice;
    }

    // 4. Update the PREVIEW DRAWER (The "None" fix)
    if (titleTargetId) {
        // Extract "hood" from "variant-title-hood"
        const partName = titleTargetId.replace('variant-title-', '');
        const drawerSpan = document.getElementById(`selected-variant-${partName}`);

        if (drawerSpan) {
            drawerSpan.textContent = variantTitle;
            
            // Fade out the text if it's an "Empty" option
            if (variantTitle.toLowerCase().includes('no ')) {
                drawerSpan.style.opacity = "0.5";
            } else {
                drawerSpan.style.opacity = "1";
            }
        }
    }

    // 5. Handle specific base logic (Front Table)
    if (part === "base") {
      const isStainlessBase = (this.dataset.variantId === stainlessBaseId);
      handleFrontTable(isStainlessBase);
    }

    // 6. Final UI refreshes
    refreshAllOverlays(isStainlessHood);
    updateTotalDisplay();
  });
});

  /**
 * UNIFIED CART INTERCEPTION
 * Handles both the main Add to Cart button and the Preview Drawer button.
 */
document.addEventListener("click", function(e) {
    // 1. Look for the button or link inside the customizer wrapper
    // This targets both <button type="submit"> and the <a> link version
    const buyButton = e.target.closest(".customizer-add-to-cart button, .customizer-add-to-cart a");

    if (buyButton) {
        // 2. Stop the theme's default scripts from running
        // Using stopImmediatePropagation is key to overriding theme behavior
        e.preventDefault();
        e.stopImmediatePropagation();

        console.log("Customizer Cart Action Triggered: ", buyButton.textContent.trim());

        // 3. Call your existing cart function
        // Note: handleDesktopAddToCart needs to be defined in your script
        handleDesktopAddToCart(e);
    }
}, true); // The 'true' parameter (capturing phase) is critical to intercepting theme events


  autoSelectSwatches();
  initMagnifier();


function preloadOverlayImages() {
  const swatches = document.querySelectorAll('.variant-swatch');
  
  // The specific attributes we need to cache
  const imageAttrs = [
    'data-overlay', 
    'data-overlay-stainless', 
    'data-zoom-overlay', 
    'data-zoom-overlay-stainless', 
    'data-overlay-stainless-base', 
    'data-zoom-overlay-stainless-base'
  ];

  swatches.forEach(swatch => {
    imageAttrs.forEach(attr => {
      let url = swatch.getAttribute(attr);

      // 1. CLEANING & VALIDATION
      // Ensure the URL exists, isn't just whitespace, and isn't the string "null"
      if (url && url.trim() !== "" && url !== "null") {
        
        // 2. PROTOCOL FIX
        // Shopify URLs often start with // - we prepend https: to help the browser
        const finalUrl = url.startsWith('//') ? 'https:' + url : url;

        // 3. THE PRELOAD
        try {
          const img = new Image();
          img.onload = () => console.log(`Preloaded: ${attr}`); // Optional debug
          img.onerror = () => console.warn(`Failed to preload: ${finalUrl}`);
          img.src = finalUrl;
        } catch (e) {
          console.error("Preload error for attribute " + attr, e);
        }
      }
    });
  });
  console.log("Performance: Overlay preloading sequence finished.");
}

    // Call this once during initialization
    preloadOverlayImages();
  }

  /**
   * REFRESH OVERLAYS
   * Forces the preview area to use high-resolution 2048x sources
   */
function refreshAllOverlays(useStainless) {
  // 1. Target the specific Front Table ID
  const specialFrontTableId = "50544105357592";
  
  // 2. Find the currently selected Front Table swatch
  const selectedTable = document.querySelector('.swatches[data-part="table"] .variant-swatch.selected');
  const isSpecialTableActive = selectedTable && selectedTable.dataset.variantId === specialFrontTableId;

  document.querySelectorAll(".variant-swatch.selected").forEach(selected => {
    const group = selected.closest(".swatches");
    if (!group) return;
    
    const part = group.dataset.part;
    const previewEl = document.getElementById(selected.getAttribute("data-preview-target"));
    if (!previewEl) return;

    let targetImg = "";

    // 3. THE COMBO OVERRIDE
    // If we are updating the BASE, and it's Stainless, and the Special Table is picked
    if (part === "base" && selected.dataset.variantId === "50544094970136" && isSpecialTableActive) {
      targetImg = selected.getAttribute("data-zoom-overlay-stainless-base") || 
                  selected.getAttribute("data-overlay-stainless-base");
      
      console.log("Special Table Combo: Swapping Base image to Table-Up version.");
    }

    // 4. FALLBACK: Standard Reactive Logic (Thermometer, Badges, etc.)
    if (!targetImg || targetImg === "") {
      const isReactive = stainlessReactiveParts.includes(part);
      targetImg = (useStainless && isReactive) 
                   ? selected.getAttribute("data-zoom-overlay-stainless") 
                   : selected.getAttribute("data-zoom-overlay");
    }

    // 5. LAST RESORT: Standard overlay source
    if (!targetImg || targetImg === "") {
      const isReactive = stainlessReactiveParts.includes(part);
      targetImg = (useStainless && isReactive) 
                   ? selected.getAttribute("data-overlay-stainless") 
                   : selected.getAttribute("data-overlay");
    }

    // 6. APPLY TO PREVIEW
    if (targetImg && targetImg !== "") {
      previewEl.src = targetImg;
      previewEl.style.display = "block";
      previewEl.dataset.zoomSrc = targetImg; // Sync with Magnifier
    } else {
      previewEl.style.display = "none";
    }
  });
}

function handleFrontTable(isStainless) {
  const frontTableGroup = document.querySelector('.swatches[data-part="table"]');
  if (!frontTableGroup) return;

  const restrictedTableId = "50544105357592"; // The Standard Table (to be disabled)
  const compatibleTableId = "50544105390360"; // The one we want to auto-select

  frontTableGroup.querySelectorAll(".variant-swatch").forEach(btn => {
    const isRestrictedTable = btn.dataset.variantId === restrictedTableId;

    if (isStainless && isRestrictedTable) {
      // 1. Disable the Standard Table
      btn.disabled = true;
      btn.style.opacity = "0.4";
      btn.style.pointerEvents = "none";
      
      // 2. If it WAS selected, remove that class
      btn.classList.remove("selected");
    } else {
      // 3. Re-enable everything else
      btn.disabled = false;
      btn.style.opacity = "1";
      btn.style.pointerEvents = "auto";
    }
  });

  // 4. NEW AUTO-SWITCH LOGIC:
  // If the base is stainless, find the compatible table and "click" it
  if (isStainless) {
    const compatibleBtn = frontTableGroup.querySelector(`.variant-swatch[data-variant-id="${compatibleTableId}"]`);
    if (compatibleBtn && !compatibleBtn.classList.contains('selected')) {
      console.log("Stainless Base selected: Auto-switching to compatible Front Table.");
      compatibleBtn.click(); // This triggers all your other logic (price, preview, etc.)
    }
  }
}

  function updateTotalDisplay() {
    let total = 0;
    document.querySelectorAll(".variant-title").forEach(el => {
      const num = parseInt(el.dataset.price, 10);
      if (!isNaN(num)) total += num;
    });
    const totalEl = document.getElementById("customizer-total-price");
    if (totalEl) totalEl.textContent = formatMoneySafe(total);
  }

  // --- 4. PREVIEW SYNC (DRAWER) ---
  function copyPreview() {
    const mainContainer = document.querySelector('#preview-area-main .preview-area');
    const drawerTarget = document.querySelector('.drawer__body_inner');
    if (!mainContainer || !drawerTarget) return;

    const clone = mainContainer.cloneNode(true);
    clone.querySelectorAll('img').forEach(img => {
      img.id = ''; 
      if (img.src && img.src !== window.location.href) img.style.display = "block";
    });

    drawerTarget.innerHTML = '';
    drawerTarget.appendChild(clone);
  }

  // --- 5. MOBILE TELEPORTATION & TABS ---
  function moveBlocks() {
    const movableBlocks = [
      { 
        selector: '.controls', 
        mobileTarget: '.mobile-customizer-swatches', 
        desktopParent: '.product-info__block-item[data-block-id="grill_customizer_block_kkgB7d"]' 
      },
      { selector: '.customizer-total-price-wrapper', mobileTarget: '.mobile-customizer-preview-price' },
      { selector: '.customizer-summary-list', mobileTarget: '.mobile-customizer-preview-info' },
      { selector: '#save-customization', mobileTarget: '.mobile-customizer-save-customization-btn' },
      { selector: '#download-design', mobileTarget: '.mobile-download-design-btn' },
      { selector: '.product-info__buy-buttons', mobileTarget: '.mobile-customizer-cart-btn' }
    ];

    movableBlocks.forEach(block => {
      const element = document.querySelector(block.selector);
      const mobileContainer = document.querySelector(block.mobileTarget);

      if (element && mobileContainer && window.innerWidth < 768) {
        if (!mobileContainer.contains(element)) {
          mobileContainer.appendChild(element);
        }
      }
    });
  }

  function initMobileNavigation() {
    const dashboard = document.querySelector(".mobile-customizer-dashboard");
    const swatchesContainer = document.querySelector(".mobile-customizer-swatches");
    const finalContainer = document.querySelector(".mobile-customizer-final");
    const backArrow = document.querySelector(".nav-back");
    const nextArrow = document.querySelector(".nav-next");
    const partBlocks = document.querySelectorAll(".part-block");
    const buildBtn = document.getElementById("build-grill-btn");
    const headerLeft = document.querySelector(".mobile-customizer-header-left");

    if (!dashboard || !swatchesContainer || !finalContainer) return;

    let currentPartIndex = 0;

    function hideAllSteps() {
      dashboard.classList.remove("active");
      swatchesContainer.classList.remove("active");
      finalContainer.classList.remove("active");
    }

    function showPart(index) {
      if (index < 0 || index >= partBlocks.length) return;
      hideAllSteps();
      swatchesContainer.classList.add("active");
      partBlocks.forEach((block, i) => {
        block.style.display = (i === index) ? "block" : "none";
      });
      currentPartIndex = index;
      if (backArrow) backArrow.style.display = "flex";
      if (nextArrow) nextArrow.style.display = "flex";
    }

    function showFinalStep() {
      hideAllSteps();
      finalContainer.classList.add("active");
      moveBlocks();
      const mainPreview = document.querySelector('#preview-area-main .preview-area');
      const mobilePreviewSlot = document.querySelector('.mobile-customizer-preview-img');
      if (mainPreview && mobilePreviewSlot) {
        mobilePreviewSlot.innerHTML = '';
        const clone = mainPreview.cloneNode(true);
        mobilePreviewSlot.appendChild(clone);
      }
      if (backArrow) backArrow.style.display = "flex";
      if (nextArrow) nextArrow.style.display = "none";
    }

    function showDashboard() {
      hideAllSteps();
      dashboard.classList.add("active");
      if (backArrow) backArrow.style.display = "none";
      if (nextArrow) nextArrow.style.display = "flex";
    }

    headerLeft?.addEventListener("click", (e) => {
      e.preventDefault();
      if (swatchesContainer.classList.contains("active") || finalContainer.classList.contains("active")) {
        showDashboard();
      }
    });

    backArrow?.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      if (finalContainer.classList.contains("active")) {
        showPart(partBlocks.length - 1);
      } else if (currentPartIndex > 0) {
        showPart(currentPartIndex - 1);
      } else {
        showDashboard();
      }
    });

    nextArrow?.addEventListener("click", (e) => {
      e.preventDefault();
      if (dashboard.classList.contains("active")) {
        showPart(0);
      } else if (currentPartIndex < partBlocks.length - 1) {
        showPart(currentPartIndex + 1);
      } else {
        showFinalStep();
      }
    });

    document.querySelectorAll(".dashboard-item").forEach((item) => {
      item.addEventListener("click", function() {
        const targetId = this.getAttribute("data-target");
        const idx = Array.from(partBlocks).findIndex(b => b.id === targetId);
        if (idx !== -1) showPart(idx);
      });
    });

    buildBtn?.addEventListener("click", () => {
      moveBlocks();
      showDashboard();
      if (typeof copyPreview === 'function') copyPreview();
    });
  }

  // --- 6. SAVE, LOAD & DELETE ---
  async function saveConfiguration() {
    if (!customerId || customerId === 'null') {
      alert("Please log in to save your design.");
      return;
    }

    const config = {};
    document.querySelectorAll(".swatches").forEach(group => {
      const selected = group.querySelector(".variant-swatch.selected");
      if (selected) {
        config[group.dataset.part] = { 
          variantId: selected.dataset.variantId, 
          title: selected.dataset.title, 
          price: selected.dataset.price 
        };
      }
    });

    let designName = currentDesignId ? allDesigns[currentDesignId].name : prompt("Name your design:");
    if (!designName) return;

    try {
      const res = await fetch(SAVE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          customer_id: customerId, 
          design_id: currentDesignId || null, 
          name: designName, 
          configuration: config 
        })
      });
      const data = await res.json();
      if (data.success) {
        alert("Design Saved!");
        await loadAllDesigns();
      }
    } catch (e) { console.error("Save failed", e); }
  }

  async function loadAllDesigns() {
    if (!customerId || customerId === 'null') return;
    try {
      const res = await fetch(`${SAVE_URL}?customer_id=${customerId}`);
      const data = await res.json();
      if (data.success) {
        const designs = data.data?.designs || data.designs || [];
        allDesigns = {};
        designs.forEach(d => { allDesigns[d.id] = { name: d.name, config: d.configuration }; });
        renderDesignList();
      }
    } catch (e) { console.error("Load failed", e); }
  }

function renderDesignList() {
  const list = document.getElementById("design-list");
  const deleteBtn = document.getElementById("delete-design"); // Find the delete button
  
  if (!list) return;
  list.innerHTML = "";

  // 1. Loop through and create the list items
  Object.entries(allDesigns).forEach(([id, design]) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "design-load-btn" + (currentDesignId === id ? " active" : "");
    btn.textContent = design.name;
    btn.onclick = () => loadSpecificDesign(id);
    list.appendChild(btn);
  });

  // 2. NEW LOGIC: Disable delete button if no design is active
  if (deleteBtn) {
    if (!currentDesignId) {
      deleteBtn.disabled = true;
      deleteBtn.style.opacity = "0.5";
      deleteBtn.style.pointerEvents = "none";
      deleteBtn.style.cursor = "not-allowed";
    } else {
      deleteBtn.disabled = false;
      deleteBtn.style.opacity = "1";
      deleteBtn.style.pointerEvents = "auto";
      deleteBtn.style.cursor = "pointer";
    }
  }
}

  function loadSpecificDesign(id) {
    const design = allDesigns[id];
    currentDesignId = id;
    Object.entries(design.config).forEach(([part, info]) => {
      const swatch = document.querySelector(`.swatches[data-part="${part}"] [data-variant-id="${info.variantId}"]`);
      if (swatch) swatch.click();
    });
    renderDesignList();
  }

  async function deleteCurrentDesign() {
    if (!currentDesignId) return;
    if (!confirm("Delete this design?")) return;
    try {
      const res = await fetch(SAVE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customer_id: customerId, design_id: currentDesignId, delete: true })
      });
      if ((await res.json()).success) {
        alert("Deleted.");
        currentDesignId = null;
        await loadAllDesigns();
      }
    } catch (e) { console.error("Delete failed", e); }
  }

  // --- 7. DOWNLOAD DESIGN LOGIC ---
async function downloadDesign() {
    const downloadBtn = document.getElementById("download-design") || document.querySelector(".mobile-download-design-btn button");
    if (downloadBtn) {
      downloadBtn.disabled = true;
      downloadBtn.textContent = "Generating...";
    }

    const isMobile = window.innerWidth < 768;
    const targetSelector = isMobile ? '.mobile-customizer-preview-img .preview-area' : '#preview-area-main .preview-area';
    const element = document.querySelector(targetSelector);

    if (!element) {
      alert("Preview area not found.");
      if (downloadBtn) {
        downloadBtn.disabled = false;
        downloadBtn.textContent = "Download Design";
      }
      return;
    }

    try {
      // 1. Identify natural dimensions (using the first visible image as reference)
      const referenceImg = element.querySelector('img[style*="display: block"]');
      const naturalWidth = referenceImg ? referenceImg.naturalWidth : 1200;
      const naturalHeight = referenceImg ? referenceImg.naturalHeight : 1200;

      // 2. Capture with explicit internal window size
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        scale: 1, // We are already using high-res natural dimensions
        width: naturalWidth,
        height: naturalHeight,
        windowWidth: naturalWidth, // Prevents responsive "squishing"
        windowHeight: naturalHeight,
        onclone: (clonedDoc) => {
          // 3. Force the cloned element to be perfectly square/unsquished
          const clonedArea = clonedDoc.querySelector(targetSelector);
          if (clonedArea) {
            clonedArea.style.width = naturalWidth + 'px';
            clonedArea.style.height = naturalHeight + 'px';
            clonedArea.style.maxWidth = 'none';
            clonedArea.style.maxHeight = 'none';
            clonedArea.style.display = 'block';
            clonedArea.style.position = 'relative';

            // Ensure all layered images fill the area perfectly
            clonedArea.querySelectorAll('img').forEach(img => {
              img.style.width = '100%';
              img.style.height = '100%';
              img.style.position = 'absolute';
              img.style.top = '0';
              img.style.left = '0';
              img.style.objectFit = 'contain';
            });
          }
        }
      });

      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = `hasty-bake-custom-${Date.now()}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (err) {
      console.error("Download Error:", err);
      alert("Capture failed. Please check your internet connection.");
    } finally {
      if (downloadBtn) {
        downloadBtn.disabled = false;
        downloadBtn.textContent = "Download Design";
      }
    }
  }

  // --- 8. MAGNIFIER ---
let magnifierInitialized = false; // Global flag

function initMagnifier() {
    // 1. Checks
    const isMobileWidth = window.matchMedia("(max-width: 768px)").matches;
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
    if (isMobileWidth || isTouchDevice) return;

    const previewArea = document.querySelector(".preview-area");
    if (!previewArea || magnifierInitialized) return; // Stop if already set up!

    previewArea.addEventListener("mousemove", function(e) {
      const { left, top, width, height } = previewArea.getBoundingClientRect();
      
      // Safety check: ensure coordinates are within bounds
      let x = ((e.clientX - left) / width) * 100;
      let y = ((e.clientY - top) / height) * 100;
      
      // Clamp values between 0 and 100 to prevent edge glitching
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));

      previewArea.querySelectorAll("img").forEach(img => {
    if (img.style.display !== "none") {
      // Find the parent swatch to get the high-res URL
      // Or better yet, store the zoom URL on the image itself during refreshAllOverlays
      const highResUrl = img.dataset.zoomSrc; 
      
      if (highResUrl && img.src !== highResUrl) {
        img.src = highResUrl; // Swap to high-res only when zooming
      }

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = "scale(2)";
    }
  });


    });

    previewArea.addEventListener("mouseleave", function() {
      previewArea.querySelectorAll("img").forEach(img => {
        img.style.transform = "scale(1)";
      });
    });

    magnifierInitialized = true; // Mark as initialized
}


  // --- 9. START OVER BUTTON ---
  function startOver() {
  
    // 1. Reset Global State
    currentDesignId = null;

    // 2. Clear current selections visually
    document.querySelectorAll(".variant-swatch").forEach(s => s.classList.remove("selected"));

    // 3. Re-run Auto-Select (This picks the first valid swatch for each part)
    autoSelectSwatches();

    // 4. Reset the Design List UI
    renderDesignList();

    // 5. Update the Display
    updateTotalDisplay();

  }


  // 10. Add to cart
async function handleDesktopAddToCart(e) {
  // 1. Stop default behavior
  if (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  // UPDATE: Use closest() because e.currentTarget won't work with delegation
  const buyButton = e.target.closest(".customizer-add-to-cart button, .customizer-add-to-cart a");
  if (!buyButton) return;

  const buttonTextDiv = buyButton.querySelector('div') || buyButton;
  
  // 2. Setup Bundle logic
  const bundleId = `bundle_${Date.now()}`;
  let items = [];

  // 3. Capture layers for Cart Preview
  const parts = ["hood", "base", "thermo", "hood_badge", "base_badge", "wheels", "table"];
  let grillLayers = {};
  parts.forEach(part => {
    const img = document.getElementById(`preview-${part}`);
    if (img && img.style.display !== "none" && img.src) {
      grillLayers[`_${part}`] = img.src; 
    }
  });

  // 4. Gather selected parts
  const selectedSwatches = document.querySelectorAll(".variant-swatch.selected");
  selectedSwatches.forEach((swatch, index) => {
    const variantId = swatch.getAttribute("data-variant-id");
    if (variantId && variantId !== "null") {
      items.push({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: Object.assign({
          "_customizer": "true",
          "_bundle_id": bundleId,
          "_bundle_title": "Custom Hasty Bake Grill",
          "_bundle_index": index + 1
        }, grillLayers)
      });
    }
  });

  if (items.length === 0) {
    alert("Please select your grill parts first.");
    return;
  }

  // 5. UI Loading State
  // Added a check: only disable if it's a real button, links can't be "disabled"
  if (buyButton.tagName === "BUTTON") {
    buyButton.disabled = true;
  } else {
    buyButton.style.pointerEvents = "none"; // Disable links visually
  }

  const originalText = buttonTextDiv.textContent;
  buttonTextDiv.textContent = "Adding Bundle...";

  // 6. Send to Shopify Cart API
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ items: items })
    });

    if (response.ok) {
      window.location.href = "/cart";
    } else {
      const errData = await response.json();
      alert("Error: " + (errData.description || "Could not add to cart. Check stock."));
    }
  } catch (err) {
    alert("Something went wrong. Please try again.");
  } finally {
    // Reset UI state
    if (buyButton.tagName === "BUTTON") {
      buyButton.disabled = false;
    } else {
      buyButton.style.pointerEvents = "auto";
    }
    buttonTextDiv.textContent = originalText;
  }
}


  //11. Load from Account Page

  function checkLoadedDesign() {
  const savedData = sessionStorage.getItem("loadedDesign");
  if (savedData) {
    const { config, id } = JSON.parse(savedData);
    currentDesignId = id; // Set the ID so "Save" updates instead of creating new
    
    // Apply the saved configuration to the swatches
    Object.keys(config).forEach(part => {
      const variantId = config[part].variantId;
      const swatch = document.querySelector(`.variant-swatch[data-variant-id="${variantId}"]`);
      if (swatch) swatch.click();
    });

    // Clear it so it doesn't stay stuck on refresh
    sessionStorage.removeItem("loadedDesign");
  }

  syncDrawerWithSelectedSwatches();
}


// 12. Sync Drawer
function syncDrawerWithSelectedSwatches() {
  // Loop through every part group
  const parts = ["hood", "base", "thermo", "hood_badge", "base_badge", "wheels", "table", "grill", "lift", "ash"];
  
  parts.forEach(part => {
    // Find the swatch that has the 'selected' class for this specific part
    // Note: Make sure your code adds a '.selected' class to the active button
    const activeSwatch = document.querySelector(`.variant-swatch.selected[data-title-target="variant-title-${part}"]`);
    const drawerSpan = document.getElementById(`selected-variant-${part}`);
    
    if (activeSwatch && drawerSpan) {
      drawerSpan.textContent = activeSwatch.getAttribute('data-title');
    }
  });
}


// Call this at the very end of your DOMContentLoaded or init function

  // --- 11 INITIALIZE ---
  moveBlocks(); 
  initSwatchesAndPreview();
  initMobileNavigation();
  loadAllDesigns();
  checkLoadedDesign();

  setTimeout(syncDrawerWithSelectedSwatches, 200);

  window.addEventListener("resize", moveBlocks);

  // Attach Listeners
  document.getElementById("save-customization")?.addEventListener("click", saveConfiguration);
  document.getElementById("delete-design")?.addEventListener("click", deleteCurrentDesign);
  document.getElementById("download-design")?.addEventListener("click", downloadDesign);
  
  // Mobile delegation for buttons that move
  document.addEventListener("click", function(e) {
    if (e.target.closest('#download-design') || e.target.closest('.mobile-download-design-btn')) {
      if (window.innerWidth < 768) downloadDesign();
    }
  });

  document.getElementById("new-design")?.addEventListener("click", () => {
    currentDesignId = null;
    document.querySelectorAll(".variant-swatch").forEach(s => s.classList.remove("selected"));
    autoSelectSwatches();
    alert("New Design started.");
    renderDesignList();
  });

  const mainPreview = document.querySelector('#preview-area-main .preview-area');
  if (mainPreview) {
    const observer = new MutationObserver(copyPreview);
    observer.observe(mainPreview, { childList: true, attributes: true, subtree: true });
    copyPreview();
  }

  // Replace your existing listener with this:
  document.getElementById("start-over")?.addEventListener("click", startOver);
});